import React from "react";
import { useLocation } from "react-router-dom";
import LegacyProfilePage from "./ProfilePage";
import V2ProfilePage from "./ProfilePage.jsx";
import { isProfileV2Path } from "../../universal/v2Routes";

export default function ProfilePageByRoute(props) {
    const location = useLocation();
    const ProfilePageComponent = isProfileV2Path(location.pathname)
        ? V2ProfilePage
        : LegacyProfilePage;
    return <ProfilePageComponent {...props} />;
}
